import { MAX_ATTEMPTS, DANGER_ATTEMPTS, GameStatus } from '../../consts';
import React, { useContext } from 'react';
import { Link } from 'react-router-dom';
import { Context } from '../../store/contextProvider';
import { restartGame } from '../../store/actions';
import { countOpenedChests } from '../../utils';
import Button from '../UI/Button/Button';
import './ControlPanel.css';

const ControlPanel = (props) => {
  const {toggle, setToggle} = props;
  const [state, dispatch] = useContext(Context);
  const { gameStatus, chests } = state;
  const openedChests = countOpenedChests(chests);
  let attemptsMade = MAX_ATTEMPTS - openedChests;

  if (attemptsMade <= DANGER_ATTEMPTS) {
    attemptsMade = (
      <span className="ControlPanel__text--danger">{attemptsMade}</span>
    );
  }

  return (
    <div className="ControlPanel">
      <p className="ControlPanel__text">
        Attempts left: {attemptsMade}/{MAX_ATTEMPTS}
      </p>
      <Button
        disabled={openedChests === 0 && gameStatus === GameStatus.IN_PROGRESS}
        onClick={() => dispatch(restartGame())}
      >
        Restart
      </Button>
      
        <Button onClick={()=>setToggle(false)}>Go to Menu</Button>
      
    </div>
  );
};

export default ControlPanel;
